import React from 'react'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import DefaultUpload from 'EurestoComponents/Upload/DefaultUpload'

import Utils from 'EurestoFonction/Utils'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {

  constructor(props) {
    super(props)
  }


  state = {
    keyUpload: Utils.getRandomNumber()
  }

  async componentDidMount() {
    this.setState({
      medias: await this.getFichierContact()
    })
  }

  getFichierContact = async () => {
    const result = await ApiRequest(project.api + 'commun', {
      action: 'list',
      requete: 'media',
      limit: 10,
      offset: 0,
      trie: [{ champ: 'date_creation', desc: true }],
      recherche: [{
        champ: 'type_media_id',
        operation: 'egal',
        valeur: this.props.location && this.props.location.query && this.props.location.query.type_media_id || 100
      }]
    }, { showAlertError: false })
    console.log(result)
    return result && result.results || []
  }

  handleUpload = result => {
    console.log(result)
    const medias = this.state.medias
    medias.push({
      lien: result.lien,
      libelle: result.libelle,
      id: result.id,
    })
    medias.move(medias.length - 1, 0)
    this.setState({
      medias: medias,
      keyUpload: Utils.getRandomNumber()
    })
  }

  handleDeleteFile = i => async _ => {
    const medias = this.state.medias

    const id = medias[i].id
    medias.splice(i, 1)
    const result = await ApiRequest(project.api + 'commun', {
      action: 'delete',
      requete: 'media',
      id: id
    }, { showAlertError: false })

    this.setState({
      medias: medias,
      keyUpload: Utils.getRandomNumber()
    })
  }

  render() {
    return <Grid container spacing={0} style={{
      margin: 0,
      padding: 0,
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      overflow: 'auto'
    }} direction="column" wrap={'nowrap'}
      justify="flex-start" alignItems="center">
      <DefaultUpload clickable key={this.state.keyUpload} typeFichier={{ id: this.props.location && this.props.location.query && this.props.location.query.type_media_id || 100 }} handleUploaded={this.handleUpload}>
        <Grid container spacing={0} style={{ margin: 0, padding: 0, width: '50vw', height: 200 }} direction="column"
          justify="center" alignItems="center">
          Déposer vos fichiers ici...
        </Grid>
      </DefaultUpload>

      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction="column"
        justify="flex-start" alignItems="center" wrap={'nowrap'}>
        {
          (this.state.medias || []).map((media, i) =>
            <Grid item style={{ position: 'relative' }}>
              <Grid container spacing={0} style={{ margin: 0, padding: 0, width: '50vw', height: 200 }} direction="row">
                <Grid item xs={8} style={{ position: 'relative' }}>
                  <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', width: '100%' }}
                    direction="column" justify={'center'} alignContent={'center'} alignItems={'center'}>
                    <img width={'auto'} height={'auto'} src={media.lien} style={{ maxWidth: '100%', maxHeight: 200 }} />
                  </Grid>
                </Grid>
                <Grid item xs={4} style={{ padding: 10 }}>
                  <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }}
                    direction="column" justify={'center'} alignContent={'center'} alignItems={'center'}>
                    <span id={'link_' + media.id}>{media.libelle}&nbsp;<i className={'btn fa fa-copy'} onClick={this.onClick(media.lien)} />&nbsp;<i className={'btn ei-commun_fermer'} onClick={this.handleDeleteFile(i)} /></span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )
        }
      </Grid>
    </Grid>

  }

  onClick = (link) => _ => {
    var textArea = document.createElement("textarea");
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/UploadGoogleStorage/index.js